<div class="campaigns">
  <a class="campaigns__back" routerLink="/suporte-tecnico">
    <i class="agres-arrow-left" aria-hidden="true"></i>
    {{ 'support-campaigns.list.back' | translate }}
  </a>

  <header class="campaigns__header">
    <div class="campaigns__header--titles">
      <p class="campaigns__header--titles---subtitle">
        {{ 'support-campaigns.list.subtitle' | translate }}
      </p>
    </div>

    <button type="button" class="campaigns__button-primary" (click)="openCreateModal()">
      <i class="agres-plus" aria-hidden="true"></i>
      {{ 'support-campaigns.list.create-button' | translate }}
    </button>
  </header>

  <div class="campaigns__toolbar">
    <div class="campaigns__search">
      <i class="agres-search" aria-hidden="true"></i>
      <label class="visually-hidden" for="campaignSearch">
        {{ 'support-campaigns.list.search-placeholder' | translate }}
      </label>
      <input
        id="campaignSearch"
        type="text"
        class="campaigns__search--input"
        [value]="searchTerm"
        (input)="onSearchChange($any($event.target).value)"
        [placeholder]="'support-campaigns.list.search-placeholder' | translate" />
    </div>

    <span class="campaigns__count">
      @if (filteredCampaigns.length === 1) {
        {{ 'support-campaigns.list.count-one' | translate: { count: filteredCampaigns.length } }}
      } @else {
        {{ 'support-campaigns.list.count-many' | translate: { count: filteredCampaigns.length } }}
      }
    </span>
  </div>

  <div class="campaigns__table-wrapper">
    <table class="campaigns__table">
      <thead>
        <tr>
          <th scope="col">{{ 'support-campaigns.list.column-image' | translate }}</th>
          <th scope="col">{{ 'support-campaigns.list.column-campaign' | translate }}</th>
          <th scope="col">{{ 'support-campaigns.list.column-status' | translate }}</th>
          <th scope="col">{{ 'support-campaigns.list.column-created-at' | translate }}</th>
          <th scope="col" class="campaigns__table--actions-header">
            {{ 'support-campaigns.list.column-actions' | translate }}
          </th>
        </tr>
      </thead>

      <tbody>
        @for (campaign of filteredCampaigns; track campaign.id) {
          <tr>
            <td>
              @if (campaign.imageUrl) {
                <img
                  class="campaigns__thumbnail"
                  [src]="campaign.imageUrl"
                  [alt]="'support-campaigns.list.thumbnail-alt' | translate" />
              } @else {
                <span class="campaigns__thumbnail campaigns__thumbnail--placeholder">
                  <i class="agres-image" aria-hidden="true"></i>
                </span>
              }
            </td>

            <td>
              <strong class="campaigns__title">{{ campaign.title }}</strong>
              <p class="campaigns__description">{{ campaign.description }}</p>
            </td>

            <td>
              <span
                class="campaigns__badge"
                [class.campaigns__badge--active]="campaign.status === campaignStatus.Active"
                [class.campaigns__badge--paused]="campaign.status === campaignStatus.Paused">
                {{ statusLabelKey(campaign.status) | translate }}
              </span>

              @if (campaign.announceOnLogin) {
                <span
                  class="campaigns__badge campaigns__badge--announced"
                  [title]="'support-campaigns.list.announced-hint' | translate">
                  {{ 'support-campaigns.list.announced' | translate }}
                </span>
              }
            </td>

            <td class="campaigns__date">{{ campaign.createdAt | date: 'dd/MM/yyyy' }}</td>

            <td>
              <div class="campaigns__actions">
                <button
                  type="button"
                  class="campaigns__actions--button"
                  (click)="openViewModal(campaign)"
                  [attr.aria-label]="'support-campaigns.list.action-view' | translate"
                  [title]="'support-campaigns.list.action-view' | translate">
                  <i class="agres-eye" aria-hidden="true"></i>
                </button>

                <button
                  type="button"
                  class="campaigns__actions--button"
                  (click)="openEditModal(campaign)"
                  [attr.aria-label]="'support-campaigns.list.action-edit' | translate"
                  [title]="'support-campaigns.list.action-edit' | translate">
                  <i class="agres-edit" aria-hidden="true"></i>
                </button>

                <button
                  type="button"
                  class="campaigns__actions--button campaigns__actions--button---danger"
                  (click)="openDeleteConfirmation(campaign)"
                  [attr.aria-label]="'support-campaigns.list.action-delete' | translate"
                  [title]="'support-campaigns.list.action-delete' | translate">
                  <i class="agres-delete" aria-hidden="true"></i>
                </button>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>

    @if (isEmpty) {
      <div class="campaigns__empty">
        <i class="agres-image" aria-hidden="true"></i>
        <strong class="campaigns__empty--title">
          {{ 'support-campaigns.list.empty-title' | translate }}
        </strong>
        <span class="campaigns__empty--hint">
          {{ 'support-campaigns.list.empty-hint' | translate }}
        </span>
      </div>
    }
  </div>
</div>

<ng-template #deleteConfirmationTemplate>
  <div class="campaigns-delete">
    <header class="campaigns-delete__header">
      <span class="campaigns-delete__header--icon">
        <i class="agres-delete" aria-hidden="true"></i>
      </span>

      <h2 class="campaigns-delete__header--heading">
        {{ 'support-campaigns.delete.title' | translate }}
      </h2>
    </header>

    <div class="campaigns-delete__body">
      <p class="campaigns-delete__body--message">
        {{ 'support-campaigns.delete.message' | translate: { title: campaignPendingDeletion?.title } }}
      </p>

      <p class="campaigns-delete__body--warning">
        <i class="agres-alert-triangle" aria-hidden="true"></i>
        <span>{{ 'support-campaigns.delete.warning' | translate }}</span>
      </p>
    </div>

    <footer class="campaigns-delete__footer">
      <button type="button" class="campaigns__button-secondary" (click)="cancelDeletion()">
        {{ 'support-campaigns.delete.cancel' | translate }}
      </button>
      <button type="button" class="campaigns__button-danger" [disabled]="isDeleting" (click)="confirmDeletion()">
        <i class="agres-delete" aria-hidden="true"></i>
        {{ 'support-campaigns.delete.confirm' | translate }}
      </button>
    </footer>
  </div>
</ng-template>
